/**
 * Every page a work order can go back to when it closes, registered once at
 * start-up (see utils/workOrderReturn). A new one adds a line here: the page
 * passes `returnTo` when it opens a work order, and supplies the handler.
 */
import { registerCustomerWorkOrderReturn } from './features/customers/customersNavigation';

export function registerWorkOrderReturns(): void {
  registerCustomerWorkOrderReturn();
}
